import app from "@/app";
import utils from "@/utils";
import DropdownController from "./dropdown-controller";
import DropdownMenuController from "./dropdown-menu-controller";
import DropdownFilterController from "./dropdown-filter-controller";
export * from "./dropdown";

utils.onControllerInit(DropdownMenuController, function() {
    utils.setControllerClass(this, "menu", "ww-dropdown__menu");
});

app.register("dropdown", DropdownController);
app.register("dropdown-menu", DropdownMenuController);   
app.register("dropdown-filter", DropdownFilterController);